import { Suspense, lazy } from 'react'

import { wwtMemo } from '@wwt/custom/wwt'

import { wwtPerformanceLog } from '@wwt/core/admin'
import { ReservationDto } from '@wwt/entities/api/search-response'
import { Offer } from '@wwt/entities/search-response'

import { ReservationButtonByOfferStatus } from '@/features/ReservationButtons'

import { ReservationTabSideTopElement } from '../types/ReservationTabSideTopElement.ts'
import { ReservationTabSidePanelReservationInfoWrapper } from './ReservationTabSidePanelReservationInfoWrapper.tsx'

const MapInfo = lazy(() =>
	import('@wwt/widgets/map').then(mod => ({ default: mod.MapInfo }))
)

interface ReservationTabSidePanelProps {
	offer: Offer
	reservation: ReservationDto
}

/**
 * Reservation tab side panel
 *
 * @author Ivan Shchedrovskyi
 */
export const ReservationTabSidePanel = wwtMemo(
	({ offer, reservation }: ReservationTabSidePanelProps) => {
		wwtPerformanceLog('ReservationTabSidePanel')

		return (
			<div className="col-span-12 flex w-full flex-col gap-y-6 sm:gap-y-8 lg:col-span-4">
				<ReservationTabSidePanelReservationInfoWrapper
					topElement={ReservationTabSideTopElement.EVERYTHING_CORRECT}
					offer={offer}
					reservation={reservation}
				/>

				<div className="flex h-[20.5rem] w-full sm:rounded-md">
					{/* TODO: Async loading */}
					<Suspense fallback={null}>
						<MapInfo
							longitude={offer.hotelStatic.geolocation.longitude}
							latitude={offer.hotelStatic.geolocation.latitude}
						/>
					</Suspense>
				</div>

				<ReservationButtonByOfferStatus
					className="mt-3 max-sm:hidden"
					offer={offer}
				/>
			</div>
		)
	}
)
